<template>
  <div>
      <h2 style="color: steelblue">Fleet Integrations Portal - Forgot Password</h2>
      <hr/><br/>
      <b-form @submit.prevent="sendMail">
          <b-form-input id="input-1" v-model="form.username" type="text" required placeholder="Enter username" />
          <br/>
          <b-button class="text-center" type="submit" >Reset & Email New Password</b-button>
          <br/><br/>
          <b-alert v-model="alert.show" :variant="alert.variant || 'info'" dismissible id="login-alert">{{alert.message}}</b-alert>
          <br/>
          <b-link class="text-center"  style="color: steelblue; font-weight: bold; font-size: 20px;" @click="auth_navigation">
            Return to Log In
          </b-link>
      </b-form>
  </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'ForgotPassword',
        data() {
            return {
                form:{},
                alert:{
                    show:false, 
                    message:'', 
                    variant:''
                },
            }
        },
        methods: {
            async sendMail(){
                try{
                    const { data } = await axios.put(
                        process.env.VUE_APP_API_URL + "bookings/reset-password",
                        this.form,
                        { headers: {'Access-Control-Allow-Origin': '*'}}
                    )
                    this.alert = {show: true, message: "An email with a new password has been sent", variant: 'success'}
                    setTimeout(() => {
                        this.$emit('auth_navigation', false)
                    }, 5000)
                } catch(e){
                    e.response && e.response.data && e.response.data.message
                    ? this.alert = {show: true, message: e.response.data.message, variant: 'danger'}
                    : this.alert = {show: true, message: "Unable to send email", variant: 'danger'}
                }
            },
            auth_navigation(){
                this.$emit('auth_navigation', false)
            }
        }
    }
    
</script>

